import { Link } from "react-router-dom";

/**
 * Single source of truth for the Delta GreenX brand lockup.
 * Renders the triangle mark image + "Delta GreenX" wordmark text together,
 * so every header/footer across the site looks identical and reinforces
 * recognition. Sizes are tuned for navbar (default), hero, and footer use.
 *
 * Usage:
 *   <BrandLogo />               // Default navbar size (28px mark, "lg" text)
 *   <BrandLogo size="sm" />     // Compact (mobile-tight, footer)
 *   <BrandLogo size="hero" />   // Large (hero banners, splash)
 *   <BrandLogo as="div" />      // Render without <Link> wrapper
 */
const SIZES = {
  sm:   { mark: "w-6 h-6",   text: "text-base" },
  md:   { mark: "w-7 h-7",   text: "text-lg" },
  lg:   { mark: "w-9 h-9",   text: "text-xl" },
  hero: { mark: "w-14 h-14", text: "text-3xl sm:text-4xl" },
};

export function BrandLogo({ size = "md", className = "", as = "link", to = "/", testid = "brand-logo" }) {
  const s = SIZES[size] || SIZES.md;
  const inner = (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid={testid}>
      <img
        src="/brand/logo-mark.png"
        alt="Delta GreenX"
        className={`${s.mark} object-contain flex-shrink-0`}
        loading="eager"
        decoding="sync"
      />
      <span className={`font-['Outfit'] ${s.text} font-bold tracking-tight text-white whitespace-nowrap`}>
        Delta <span className="text-[#22C55E]">GreenX</span>
      </span>
    </span>
  );
  if (as === "link") {
    return (
      <Link to={to} className="inline-flex items-center" aria-label="Delta GreenX home">
        {inner}
      </Link>
    );
  }
  return inner;
}

export default BrandLogo;
